<script>
import {
  DigitalProductCardElementMixin,
} from "%/dynamic-component-editor/standard-components/digital-product-card/digital-product-card-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "DigitalProductBuyButton",
  elementPanelSettings: {
    displayName: "Buy",
    elementGroup: "digitalProductElements",
  },
  extends: BaseButtonElement,
  mixins: [DigitalProductCardElementMixin],
  methods: {
    handleButtonClick() {
      return this.editMode ? null : this.buyDigitalProduct();
    },
  },
};
</script>
